module.exports = __webpack_public_path__ + "media/customizations/moonlight/back-15203c372eddf8eceef50593f542f73c.jpg";